import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {message} from "antd"
import agent from '../../agent';
import {
  UPDATE_CURRENT_USER
} from '../../constants/actionTypes';

import {updateUser} from '../../actions/user'
import {getLabel} from "../../language";
import "./Setting.css"

message.config({top:50})

const mapStateToProps = state => ({
  currentUser: state.common.currentUser,
    anonymousMode: state.user.anonymousMode
});

class PrivacyTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMyProfile: 0,
      viewMyPostsAndComments: 0,
      replyMyPostsAndComments: 0,
      mentionMe: 0,
      sendMeDirectMessage: 0,
      viewMyVotes: 0,
      isDisabled : true
    };

    this.onChange = this.onChange.bind(this);
    this.setUserState = this.setUserState.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this)
    this.showErrorLabel73 = this.showErrorLabel73.bind(this)

  }

  setUserState(user) {
    if(user) {
      const {
        mentionMe,
        replyMyPostsAndComments,
        sendMeDirectMessage,
        viewMyPostsAndComments,
        viewMyProfile,
        viewMyVotes,
      } = user;
      this.setState({ ...this.state, mentionMe, replyMyPostsAndComments, sendMeDirectMessage, viewMyPostsAndComments, viewMyProfile, viewMyVotes});
    }
  }

  onChange(e) {

    this.setState({
      [e.target.name]: parseInt(e.target.value),
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setUserState(nextProps.currentUser);
  }

  componentDidMount() {
    this.setUserState(this.props.currentUser);
    const {currentUser} = this.props;
    this.setState({isDisabled : currentUser?.user_privilege?.mayPostToPublic });
  }

    showErrorLabel73() {
        if (!this.state.isDisabled) {
            message.error(getLabel(274))
        }
    }

    submitForm = () => {

        const user = Object.assign({}, this.state);
        if (!user.password) {
            delete user.password;
        }
        delete user.image;

        let formData = new FormData();
        let data = {}
        data.userName = this.props?.currentUser?.userName || ''
        data.firstName = this.props?.currentUser?.firstName || ''
        data.lastName = this.props?.currentUser?.lastName || ''
        data.viewMyProfile = user.viewMyProfile || ''
        data.displayName = this.props?.currentUser?.displayName || ''
        data.viewMyPostsAndComments = user.viewMyPostsAndComments || ''
        data.replyMyPostsAndComments = user.replyMyPostsAndComments || ''
        data.mentionMe = user.mentionMe || ''
        data.sendMeDirectMessage = user.sendMeDirectMessage || ''
        data.viewMyVotes = user.viewMyVotes || ''
        data.gender = this.props?.currentUser?.gender || ''
        data.bio = this.props?.currentUser?.bio || ''
        data.referToMeAs = this.props?.currentUser?.referToMeAs || ''
        data.genderText = this.props?.currentUser?.genderText || ''
        data.displayLocation = this.props?.currentUser?.displayLocation || ''
        data.password = ''

        for ( const key in data ) {
            formData.append(key, data[key]);
        }
        this.props.updateUser(this.props?.currentUser?.userName,formData);
    };

  render() {
      const { anonymousMode } = this.props
    return (
      <div>
          <div className={`row privacy-tab`} >
              <div className="col-md-6">
                  <legend className={`${anonymousMode ? "cw" : ""}`}>{getLabel(187)}</legend>
                  <fieldset className={`form-group privacy-list ${anonymousMode ? "bgl cw" : ""}`}>
                      <div className="form-check">
                          <input type="radio"
                                 onChange={this.onChange}
                                 className="form-check-input"
                                 name="viewMyProfile"
                                 id="viewMyProfile2"
                                 value="2"
                                 checked={this.state.viewMyProfile == 2}
                          />
                          <label className="form-check-label" for="viewMyProfile2">{getLabel(72)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 onChange={this.onChange}
                                 className="form-check-input"
                                 name="viewMyProfile"
                                 id="viewMyProfile3"
                                 value="3"
                                 checked={this.state.viewMyProfile == 3}
                          />
                          <label className="form-check-label" for="viewMyProfile3">{getLabel(188)}</label>
                      </div>
                  </fieldset>
              </div>
              <div className="col-md-6">
                  <legend className={`${anonymousMode ? "cw" : ""}`}>{getLabel(189)}</legend>
                  <fieldset className={`form-group privacy-list ${anonymousMode ? "bgl cw" : ""}`}>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="sendMeDirectMessage"
                                 id="sendMeDirectMessage2"
                                 value="2"
                                 checked={this.state.sendMeDirectMessage == 2}
                          />
                          <label className="form-check-label" for="sendMeDirectMessage2">{getLabel(72)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="sendMeDirectMessage"
                                 id="sendMeDirectMessage3"
                                 value="3"
                                 checked={this.state.sendMeDirectMessage == 3}
                          />
                          <label className="form-check-label" for="sendMeDirectMessage3">{getLabel(188)}</label>
                      </div>
                  </fieldset>
              </div>
          </div>
          <div className="row">
          <div className="col-md-6">
                  <legend className={`${anonymousMode ? "cw" : ""}`}>{getLabel(70)}</legend>
                  <fieldset className={`form-group privacy-list ${anonymousMode ? "bgl cw" : ""}`}>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="viewMyPostsAndComments"
                                 id="viewMyPostsAndComments1"
                                 value="1"
                                 checked={this.state.viewMyPostsAndComments == 1}
                          />
                          <label className="form-check-label" for="viewMyPostsAndComments1">{getLabel(71)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="viewMyPostsAndComments"
                                 id="viewMyPostsAndComments2"
                                 value="2"
                                 checked={this.state.viewMyPostsAndComments == 2}
                          />
                          <label className="form-check-label" for="viewMyPostsAndComments2">{getLabel(72)}</label>
                      </div>
                      <div className="form-check" onClick={this.showErrorLabel73}>
                          <input type="radio"
                                 className={`form-check-input`}
                                 onChange={this.onChange}
                                 name="viewMyPostsAndComments"
                                 id="viewMyPostsAndComments3"
                                 value="3"
                                 disabled={!this.state.isDisabled ? true : false}
                                 checked={ this.state.viewMyPostsAndComments == 3}
                          />
                          <label className={` ${!this.state.isDisabled ? "optionGrey" : "form-check-label"}`} for="viewMyPostsAndComments3" >{getLabel(73)}</label>
                      </div>
                  </fieldset>
              </div>
              <div className="col-md-6">
                  <legend className={`${anonymousMode ? "cw" : ""}`}>Who can mention me</legend>
                  <fieldset className={`form-group privacy-list ${anonymousMode ? "bgl cw" : ""}`}>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="mentionMe"
                                 id="mentionMe1"
                                 value="1"
                                 checked={this.state.mentionMe == 1}
                          />
                          <label className="form-check-label" for="mentionMe1">{getLabel(71)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="mentionMe"
                                 id="mentionMe2"
                                 value="2"
                                 checked={this.state.mentionMe == 2}
                          />
                          <label className="form-check-label" for="mentionMe2">{getLabel(72)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="mentionMe"
                                 id="mentionMe3"
                                 value="3"
                                 checked={this.state.mentionMe == 3}
                          />
                          <label className="form-check-label" for="mentionMe3">{getLabel(73)}</label>
                      </div>
                  </fieldset>
              </div>
          </div>
          <div className="row">
          <div className="col-md-6">
                  <legend className={`${anonymousMode ? "cw" : ""}`}>{getLabel(190)}</legend>
                  <fieldset className={`form-group privacy-list ${anonymousMode ? "bgl cw" : ""}`}>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 id="replyMyPostsAndComments1"
                                 onChange={this.onChange}
                                 name="replyMyPostsAndComments" value="1"
                                 checked={this.state.replyMyPostsAndComments == 1}
                          />
                          <label className="form-check-label" for="replyMyPostsAndComments1">{getLabel(71)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="replyMyPostsAndComments"
                                 id="replyMyPostsAndComments2"
                                 value="2"
                                 checked={this.state.replyMyPostsAndComments == 2}
                          />
                          <label className="form-check-label" for="replyMyPostsAndComments2">{getLabel(72)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="replyMyPostsAndComments"
                                 id="replyMyPostsAndComments3"
                                 value="3"
                                 checked={this.state.replyMyPostsAndComments == 3}
                          />
                          <label className="form-check-label" for="replyMyPostsAndComments3">{getLabel(73)}</label>
                      </div>
                  </fieldset>
              </div>
              <div className="col-md-6">
                  <legend className={`${anonymousMode ? "cw" : ""}`}>{getLabel(191)}</legend>
                  <fieldset className={`form-group privacy-list ${anonymousMode ? "bgl cw" : ""}`}>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="viewMyVotes"
                                 id="viewMyVotes1"
                                 value="1"
                                 checked={this.state.viewMyVotes == 1}
                          />
                          <label className="form-check-label" for="viewMyVotes1">{getLabel(71)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="viewMyVotes"
                                 id="viewMyVotes2"
                                 value="2"
                                 checked={this.state.viewMyVotes == 2}
                          />
                          <label className="form-check-label" for="viewMyVotes2">{getLabel(72)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="viewMyVotes"
                                 id="viewMyVotes3"
                                 value="3"
                                 checked={this.state.viewMyVotes == 3}
                          />
                          <label className="form-check-label" for="viewMyVotes3">{getLabel(73)}</label>
                      </div>
                      <div className="form-check">
                          <input type="radio"
                                 className="form-check-input"
                                 onChange={this.onChange}
                                 name="viewMyVotes"
                                 id="viewMyVotes4"
                                 value="4"
                                 checked={this.state.viewMyVotes == 4}
                          />
                          <label className="form-check-label" for="viewMyVotes4">{getLabel(78)}</label>
                      </div>
                  </fieldset>
              </div>
          </div>
          <hr />
          <button
            className={`btn btn-lg btn-primary${anonymousMode ? "-dark" : ""} float-right`}
            type="button"
            disabled={this.state.inProgress}
            onClick={() =>this.submitForm() }>
              {getLabel(184)}
          </button>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, {updateUser})(PrivacyTab));
